var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 31,
    viewBox: "0 0 35 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9703 27.188C26.3944 27.8913 24.2295 28.255 21.4757 28.2791C18.7805 28.3026 16.1981 27.8251 13.7285 26.8468C11.3176 25.8679 9.25553 24.5929 7.54253 23.0219C3.94022 19.8123 2.12108 16.1561 2.08527 12.0534C2.05067 8.0885 3.75457 5.26357 7.19712 3.57852C9.12285 2.66525 11.4039 2.19711 14.0405 2.1741C19.2552 2.1286 23.8976 3.6569 27.9678 6.75899C32.038 9.86109 34.0921 13.5842 34.13 17.9283C34.1682 22.3068 32.115 25.3933 27.9703 27.188Z",
    fill: "#FFC8B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0346 0.339653C16.599 -0.113218 17.401 -0.113218 17.9654 0.339653L29.556 9.6394C29.5559 9.63931 29.5561 9.63948 29.556 9.6394L33.4199 12.7397C34.0864 13.2744 34.1945 14.2498 33.6613 14.9183C33.1281 15.5867 32.1556 15.6951 31.4891 15.1603L30.1363 14.075V29.45C30.1363 30.306 29.4444 31 28.5909 31H5.40913C4.5556 31 3.86368 30.306 3.86368 29.45V14.075L2.51094 15.1603C1.84445 15.6951 0.871908 15.5867 0.338713 14.9183C-0.194482 14.2498 -0.0864218 13.2744 0.580072 12.7397L4.4437 9.63965C4.44354 9.63978 4.44385 9.63953 4.4437 9.63965L16.0346 0.339653ZM6.95458 11.595L17 3.53497L27.0454 11.595V27.9H22.4091V19.375C22.4091 18.519 21.7172 17.825 20.8636 17.825H13.1364C12.2828 17.825 11.5909 18.519 11.5909 19.375V27.9H6.95458V11.595ZM14.6818 27.9H19.3182V20.925H14.6818V27.9Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/HomeIcon.0b874b350b468dd09ffa035fa73ae097.svg";
export { ForwardRef as ReactComponent };